"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typings_1 = require("../typings");
var Baobab_Logger_1 = require("../Baobab/Baobab-Logger");
function createChildData(props, def, val) {
    if (val === void 0) { val = {}; }
    var result = {
        name: val.name || def.name,
    };
    var key = val.key || def.key;
    if (key)
        result.key = key;
    if (def.events || val.events)
        result.events = __assign(__assign({}, def.events), val.events);
    if (def.attrs || val.attrs) {
        var defAttrs = typings_1.isNodeAttrsConstructor(def.attrs) ? def.attrs(props) : def.attrs;
        var valAttrs = typings_1.isNodeAttrsConstructor(val.attrs) ? val.attrs(props) : val.attrs;
        result.attrs = __assign(__assign({}, defAttrs), valAttrs);
    }
    return result;
}
exports.createChildData = createChildData;
function createRootData(props, def, val) {
    var result = createChildData(props, def, val);
    if (result.attrs === undefined)
        result.attrs = {};
    if (!('schema-ver' in result.attrs))
        result.attrs['schema-ver'] = Baobab_Logger_1.SCHEMA_VER;
    return result;
}
exports.createRootData = createRootData;
function areEqualsNodes(node, nodeInfo, parent) {
    var _a, _b;
    if (node.key || nodeInfo.key)
        return node.key === nodeInfo.key;
    if (node.name !== nodeInfo.name)
        return false;
    if ('parent' in node && node.parent.id !== ((_a = parent) === null || _a === void 0 ? void 0 : _a.id))
        return false;
    if (!('parent' in node) && ((_b = parent) === null || _b === void 0 ? void 0 : _b.id))
        return false;
    var nodeAttrs = node.attrs;
    var nodeInfoAttrs = nodeInfo.attrs;
    if (nodeAttrs === nodeInfoAttrs)
        return true;
    if (!nodeAttrs || !nodeInfoAttrs)
        return false;
    if (Object.keys(nodeAttrs).length !== Object.keys(nodeInfoAttrs).length)
        return false;
    for (var key in nodeAttrs) {
        if (nodeAttrs[key] !== nodeInfoAttrs[key])
            return false;
    }
    return true;
}
exports.areEqualsNodes = areEqualsNodes;
